// extracted by mini-css-extract-plugin
module.exports = {"title":"PopularArticles_title__TQgtk","articlesGrid":"PopularArticles_articlesGrid__4p8e5"};